export default "__VITE_ASSET__lZh4p6Wp__"